import { DataGetter, Utag, TealiumData } from "../types";
import { afterNextPaint } from "./afterNextPaint";
import { debugLog } from "./debugLog";

export const trackEvent = (
  getUtag: () => Promise<Utag>,
  viewData: TealiumData,
  getEventData: DataGetter,
): Promise<void> =>
  getUtag()
    .then((utag) => {
      const eventData = getEventData();
      const data = {
        ...viewData,
        event: eventData,
      };
      afterNextPaint(() => {
        debugLog(`Sending CUSTOM_EVENT_TRACK_EVENT data to tealium:`, data);
        utag.link(data);
      });
    })
    .catch((e) => {
      console.warn(
        "@rea-argonaut/analytics trackEvent was unable to get utag",
        e,
      );
    });
